import React from "react";
import styled from "styled-components";
import { TriangleAlert } from "lucide-react";
import { useTranslation } from "react-i18next";

import { Color } from "../../constants/color";
import { useSolaLettura } from "../../features/user/solaLettura";

// L'avviso che l'azienda è in sola lettura (ODOO 300). Una barra e non un toast, come
// l'avviso della lista attestati incompleta: la condizione dura finché l'abbonamento resta
// disattivato, e chi arriva su una pagina deve sapere perché i comandi di modifica non ci sono.
// Sta in ogni pagina protetta, perché riguarda tutte.
const Barra = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  box-sizing: border-box;
  width: calc(100% - 2rem);
  max-width: 1400px;
  margin: 1rem auto;
  padding: 1rem 1.25rem;
  border: 1px solid ${Color.ORANGE};
  border-radius: 0.75rem;
  background-color: ${Color.LIGHT_YELLOW};
  text-align: left;

  & p.titolo {
    font-family: "Avenir Next Bold", sans-serif;
    font-weight: bold;
    color: ${Color.DARK_GREY};
  }

  & p.dettaglio {
    font-size: 0.95rem;
    color: ${Color.DARK_GREY};
    max-width: 90ch;
  }
`;

export function AvvisoSolaLettura() {
  const { t } = useTranslation();
  const solaLettura = useSolaLettura();
  if (!solaLettura) return null;
  return (
    <Barra role="status">
      <TriangleAlert color={Color.ORANGE} size={24} strokeWidth={2} />
      <div>
        <p className="titolo">{t("sola-lettura-titolo")}</p>
        <p className="dettaglio">{t("sola-lettura-dettaglio")}</p>
      </div>
    </Barra>
  );
}

export default AvvisoSolaLettura;
